import { Trans, useTranslation } from "react-i18next";
import { MessageType, Modal } from "../../../../common/components";
import { showToast } from "../../../../common/services/toast";
import { useDeleteAnnouncement } from "../../api";
import { Announcement } from "../../models";
import { getAnnouncementTranslation } from "../../utils";

interface DeleteAnnouncementModalProps {
    isOpen: boolean;
    onClose?: () => void;
    onCloseAnimationEnd?: () => void;
    announcement: Announcement | null;
    onSuccess?: () => void;
}

const DeleteAnnouncementModal = (props: DeleteAnnouncementModalProps) => {
    const { isOpen, onClose, onCloseAnimationEnd, announcement, onSuccess } =
        props;

    const { t, i18n } = useTranslation(["common", "announcements", "toast"]);

    const title =
        getAnnouncementTranslation(
            announcement?.translations ?? [],
            i18n.language
        )?.title ?? "";

    const { triggerDeleteAnnouncement, isLoadingDeleteAnnouncement } =
        useDeleteAnnouncement({
            onSuccess: () => {
                onSuccess?.();
                onClose?.();
            },
            onError: () =>
                showToast({
                    summary: t("toast:announcements.deleteFailed.title"),
                    detail: t("toast:announcements.deleteFailed.description"),
                    severity: MessageType.ERROR,
                }),
        });

    const handleDeleteClick = () => {
        if (!announcement || isLoadingDeleteAnnouncement) return;
        triggerDeleteAnnouncement({ announcementId: announcement.id });
    };

    return (
        <Modal
            isOpen={isOpen}
            isOkButtonDisabled={isLoadingDeleteAnnouncement}
            isOkLoading={isLoadingDeleteAnnouncement}
            title={t("announcements:deleteAnnouncement.title")}
            hasOkButton
            okButtonType="danger"
            hasCancelButton
            okText={t("common:delete")}
            cancelText={t("common:cancel")}
            onClickOk={handleDeleteClick}
            onClickCancel={() => onClose?.()}
            onClickClose={() => onClose?.()}
            onClickCloseAnimationEnd={onCloseAnimationEnd}
        >
            <Trans
                i18nKey="announcements:deleteAnnouncement.description"
                values={{ title }}
            />
        </Modal>
    );
};

export default DeleteAnnouncementModal;
